import ApiClient from './ApiClient';

class GiveawaysClient {
  constructor(authToken, eventId) {
    this.apiClient = new ApiClient();
    this.gatewayUri = 'api/v1';
    this.latestVersion = 'v1';
    this.baseUri = process.env.VUE_APP_HACKATHON_SERVICE_URI;
    this.eventId = eventId;
    this.headers = {
      Authorization: `Bearer ${authToken}`,
    };
    this.uri = `${this.baseUri}${this.gatewayUri}/events/${this.eventId}`;
    this.params = {};
  }

  getGiveaways() {
    return this.apiClient.get(`${this.uri}/giveaways`, this.params, this.headers)
      .then((response) => response.data);
  }

  redeemGiveaway(giveawayType, giveawaySubtype) {
    const dataBody = {};
    return this.apiClient.post(`${this.uri}/giveaways/${giveawayType}/${giveawaySubtype}`, dataBody, this.headers)
      .then((response) => response.data);
  }

  addGiveaways(giveawayType, giveawaySubtype, codes) {
    const dataBody = {
      type: giveawayType,
      subtype: giveawaySubtype,
      values: codes,
    };
    return this.apiClient.post(`${this.uri}/giveaways`, dataBody, this.headers);
  }

  loadUnredeemedGiveaways(giveawayType, giveawaySubtype) {
    const dataBody = {};
    return this.apiClient.post(`${this.uri}/admin/giveaways/${giveawayType}/${giveawaySubtype}`, dataBody, this.headers);
  }
}
export default GiveawaysClient;
